export enum SidebarAction {
  close = 'close',
  submit = 'submit',
  cancel = 'cancel',
}
